import { clsx } from 'clsx'

import { T, useStaticIntl } from '@tribeplatform/react-components/i18n'
import { List } from '@tribeplatform/react-ui-kit/Layout'
import { Modal } from '@tribeplatform/react-ui-kit/Modal'

import { emailStatusMappingFactory } from './constants.js'

export const EmailStatusModal = ({
  open,
  onClose,
}: {
  open: boolean
  onClose: () => void
}) => {
  const emailStatusMapping = useStaticIntl(emailStatusMappingFactory)
  return (
    <Modal open={open} onClose={onClose} size="2xl">
      <Modal.Header title="Email status guide" />
      <Modal.Content>
        <List className="list-disc list-outside px-5">
          {Object.keys(emailStatusMapping).map(status => {
            const emailStatus = emailStatusMapping[status]

            return (
              <List.Item key={status}>
                <T
                  defaultMessage="{status_title}: {status_description}."
                  id="Admin.EmailStatus.DescriptionTemplate"
                  values={{
                    status_title: (
                      <span
                        className={clsx('font-medium', emailStatus.className)}
                      >
                        {emailStatus.title}
                      </span>
                    ),
                    status_description: emailStatus.description,
                  }}
                />
              </List.Item>
            )
          })}
        </List>
      </Modal.Content>
    </Modal>
  )
}
